<template>
  <div class="container">
    <div class="starter-template fill">
      <h1>Oooops...</h1>
      <p class="lead">{{ $t('message.page_not_found') }}</p>
      <p class="lead">{{ currentUrl }}</p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PageNotFound',
  data() {
    return {
      currentUrl: window.location.href,
    }
  },
}
</script>
